import React, {createContext, ReactNode, useContext, useEffect, useState} from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";
import {StepTitleContent} from "../PanelContents/StepTitleContent";
import {ImageAnswerComponent} from "../PanelContents/ImageAnswer";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";
import ZooPassAnswerAvailabilityUtility from "../../Utilities/ZooPassAnswerAvailabilityUtility";
import {PassSelectCard} from "../PanelContents/PassSelectCard";
import DataFormComponent from '../PanelContents/DataFormComponent';
import ZooPassStepDataUtility from '../../Utilities/ZooPassStepDataUtility';

export const Step7Panel : React.FC = () => {

    const [rows, setRows] = useState<Array<ReactNode>>([]);

    const [showDataForm, setShowDataForm] = useState<boolean>(false);
    const [guests, setGuests] = useState<null | 0 | 1 | 2 | 3 | 4>(0);
    const [selectedPass, setSelectedPass] = useState<string | null>(null);
    
    let {
        textTitles,
        zooPassMembership,
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading,
        updateContext
    } = useZooPassAppAnswersContext();

    useEffect(() => {
        if(answersData == null || zooPassMembership == null){
            setRows([]);
            return;
        }
        
        const result = ZooPassAnswerAvailabilityUtility.CalculatePassCategory(answersData, zooPassMembership);
        
        if(result == null){
            setRows([]);
            return;
        }
        
        let newRows : Array<ReactNode> = [];
        result.items.forEach((option, index) => {
            if(!option) return;
            const recommend = index === result.recommended;
            newRows.push(<PassSelectCard membership={option} isRecommended={recommend} key={option.fetchKey} 
                                         isGift={answersData.step1Value == 1} yearNumber={1}
                                         summary={ZooPassAnswerAvailabilityUtility.BuildSummary(answersData, option)} 
                                         onClick={() => handleValueClick(option?.fetchKey)} onKeyboardPress={(event) => handleOptionKeyPress(event, option?.fetchKey)}/>);
        });
        setRows(newRows);
        
    }, [answersData, answersData?.step, answersData?.step3Value, answersData?.step4FinalValue, answersData?.step5Value]);
    
    const handleValueClick = (value: null | string) => {
        console.log(value, answersData, showDataForm);
        // Account for slecting the pass
        value = value ?? selectedPass;
        if(answersData !== null)
        {
            // set the value
            answersData.step7Value = value;

            setSelectedPass(value);

            // check and validate the pass and make sure that they do not need to selected an adult.
            const result = ZooPassAnswerAvailabilityUtility.CalculatePassCategory(answersData, zooPassMembership);

            const option = result?.items.find(x => x?.fetchKey === value);

            let upgrade = false;
            if (answersData.step3Value == 1 && option?.lookup.adults == 2) {
                upgrade = true;
                setGuests(option.lookup.guests)
            }

            if (upgrade) {
                setShowDataForm(true);
            } else {
                if(showDataForm && answersData.step3Value == 1) {
                    setShowDataForm(false);
                }
                const validation = ZooPassStepDataUtility.IsFormDataValid(answersData.formData, answersData.step3Value == 2, answersData.step1Value == 1);
                console.log(validation);
                if(value != null 
                    && (!showDataForm 
                        || answersData.step3Value == 1 
                        || (answersData.step3Value == 2 
                    && validation))){
                    answersData.previousStep = answersData.step;
                    answersData.step = 8;
                }
            }

            console.log(answersData);
            
            ZooPassLocalStateUtility.SetLocalState(answersData);
            updateContext({ type: "setAnswers", value: { ...answersData }});
        }
    }

    const handleOptionKeyPress = (event : any, value: null | string) => {
        if(!event.altKey && !event.metaKey && !event.shiftKey && event.key === 'Enter') {
            handleValueClick(value);
        }
    }
    
    return !answersLoading && !loading && 
        textTitles !== null &&
        answersData !== null && answersData.step == 7 && (
        <div className="container d-block">
            <StepTitleContent textTitle={textTitles.get("ZooPass:PageContent:07")}/>
            <div className="row g-4 mx-auto row-cols-1 row-cols-md-2 row-cols-lg-3 justify-content-center w-auto">
                {rows}
            </div>
            { showDataForm && <>
                <DataFormComponent override={true} />
                <div style={{textAlign: 'right', maxWidth: '600px', margin: '0 auto'}}>
                    <button className="btn btn-success mt-4" onClick={() => {
                        answersData.step3Value = 2;
                        answersData.step5Value = guests;
                        handleValueClick(answersData.step7Value)
                    }} disabled={!ZooPassStepDataUtility.IsFormDataValid(answersData.formData, true, answersData.step1Value == 1) && !(!answersData?.step3Value)}>Continue</button>
                </div>
                </>}
        </div>
        );
};

